import React, {Component} from "react"
import {Label, OverlayTrigger, Tooltip} from "react-bootstrap"
import memorieLogo from "../images/apps/memorie.png"
import smartyLogo from "../images/apps/smarty.png"
import galiniLogo from "../images/apps/galini.png"
import trufocusLogo from "../images/apps/trufocus.png"
import {APPLICATION_DISPLAY_NAME} from "../constants"

const logoMap = {
  memorie: memorieLogo,
  smarty: smartyLogo,
  galini: galiniLogo,
  trufocus: trufocusLogo,
}

class ApplicationIcon extends Component {
  render() {

    const app = this.props.application || {}

    const tooltip = (
      <Tooltip id="tooltip">
        {app.displayName || APPLICATION_DISPLAY_NAME[app.name]}
      </Tooltip>
    );

    return logoMap[app.name] ? (

        <OverlayTrigger placement="top" overlay={tooltip}>
          <img src={logoMap[app.name]} className={`img-sm img-rounded ${this.props.className || ''}`}/>
        </OverlayTrigger>

      )
      :
      null
  }
}

export default ApplicationIcon



// WEBPACK FOOTER //
// ./src/components/ApplicationIcon.js